module.exports = __webpack_public_path__ + "static/media/162-somaliland.05897583.svg";